import { createContext, type PropsWithChildren, useContext } from 'react';
import type { AuthInfo } from '../hook/model/authInfo';

type Project = AuthInfo.Project;
type SelectedProject = AuthInfo.SelectedProject;

type SwitchProject = (params: { id: Project['id'] }) => void;

type Context = {
  project: SelectedProject | undefined;
  projects: Project[];
  switchProject: SwitchProject;
};

const ProjectContext = createContext<Context>({
  projects: [],
  project: undefined,
  switchProject: () => {},
});

export const useProject = () => {
  const { project, switchProject, projects } = useContext(ProjectContext);
  if (!project) throw new Error('ProjectProvider is not found');
  return { project, switchProject, projects };
};

export const ProjectProvider: React.FC<PropsWithChildren<Context>> = (props) => {
  const { project, switchProject, projects, children } = props;
  return <ProjectContext.Provider value={{ project, switchProject, projects }}>{children}</ProjectContext.Provider>;
};
